import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Banner from 'components/Banner';
import DistributionContacts from 'components/DistributionContacts';
import ContactsCards from './ContactsCards';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { selectContactsPage } from 'store/slices/ContactsSlice';
import { fetchContacts } from 'store/slices/ContactsSlice';

const Contacts = () => {
    const dispatch = useDispatch();

    const {
        fs_title,
        fs_background,
        fs_button,
        international_tag,
        international_title,
        international_text,
        contacts,
        contact_tag,
        contact_title,
    } = useSelector(selectContactsPage);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchContacts());
    }, [dispatch]);
    return (
        <>
            <Banner title={fs_title} image={fs_background} buttonText={fs_button} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{international_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: international_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">{international_text}</GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <DistributionContacts />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{contact_tag}</LabelButton>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="middle">
                                <span dangerouslySetInnerHTML={{ __html: contact_title }} />
                            </GradientText>
                        </div>
                    </div>

                    <ContactsCards data={contacts} />
                </div>
            </section>

            <DefaultForm />
        </>
    );
};

export default Contacts;
